import { denormalisedResponseEntities } from '../../util/data';
import { storableError } from '../../util/errors';
import { currentUserShowSuccess, fetchCurrentUser } from '../../ducks/user.duck';
import { calculateProfileTier } from '../../util/api';

// ================ Action types ================ //

export const UPLOAD_IMAGE_REQUEST = 'app/BasicInformationPage/UPLOAD_IMAGE_REQUEST';
export const UPLOAD_IMAGE_SUCCESS = 'app/BasicInformationPage/UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_IMAGE_ERROR = 'app/BasicInformationPage/UPLOAD_IMAGE_ERROR';

export const UPDATE_PROFILE_REQUEST = 'app/BasicInformationPage/UPDATE_PROFILE_REQUEST';
export const UPDATE_PROFILE_SUCCESS = 'app/BasicInformationPage/UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_ERROR = 'app/BasicInformationPage/UPDATE_PROFILE_ERROR';

export const SET_INITIAL_STATE = 'app/BasicInformationPage/SET_INITIAL_STATE';

// ================ Reducer ================ //

const initialState = {
  image: null,
  uploadImageError: null,
  uploadInProgress: false,
  updateInProgress: false,
  updateProfileError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case UPLOAD_IMAGE_REQUEST:
      return {
        ...state,
        image: { ...payload.params },
        uploadInProgress: true,
        uploadImageError: null,
      };
    case UPLOAD_IMAGE_SUCCESS: {
      const { id, uploadedImage } = payload;
      const { file } = state.image || {};
      const image = { id, imageId: uploadedImage.id, file, uploadedImage };
      return { ...state, image, uploadInProgress: false };
    }
    case UPLOAD_IMAGE_ERROR:
      return { ...state, image: null, uploadInProgress: false, uploadImageError: payload.error };

    case UPDATE_PROFILE_REQUEST:
      return { ...state, updateInProgress: true, updateProfileError: null };
    case UPDATE_PROFILE_SUCCESS:
      return { ...state, image: null, updateInProgress: false };
    case UPDATE_PROFILE_ERROR:
      return { ...state, updateInProgress: false, updateProfileError: payload };

    case SET_INITIAL_STATE:
      return initialState;

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const uploadImageRequest = params => ({ type: UPLOAD_IMAGE_REQUEST, payload: { params } });
export const uploadImageSuccess = result => ({ type: UPLOAD_IMAGE_SUCCESS, payload: result.data });
export const uploadImageError = error => ({
  type: UPLOAD_IMAGE_ERROR,
  payload: error,
  error: true,
});

export const updateProfileRequest = () => ({ type: UPDATE_PROFILE_REQUEST });
export const updateProfileSuccess = result => ({
  type: UPDATE_PROFILE_SUCCESS,
  payload: result.data,
});
export const updateProfileError = error => ({
  type: UPDATE_PROFILE_ERROR,
  payload: error,
  error: true,
});

export const setInitialState = () => ({ type: SET_INITIAL_STATE });

// ================ Thunks ================ //

export const uploadImage = actionPayload => (dispatch, getState, sdk) => {
  const id = actionPayload.id;
  dispatch(uploadImageRequest(actionPayload));

  const bodyParams = { image: actionPayload.file };
  const queryParams = {
    expand: true,
    'fields.image': ['variants.square-small', 'variants.square-small2x'],
  };

  return sdk.images
    .upload(bodyParams, queryParams)
    .then(resp => {
      const uploadedImage = resp.data.data;
      dispatch(uploadImageSuccess({ data: { id, uploadedImage } }));
    })
    .catch(e => dispatch(uploadImageError({ id, error: storableError(e) })));
};

export const updateProfile = actionPayload => (dispatch, getState, sdk) => {
  dispatch(updateProfileRequest());

  const queryParams = {
    expand: true,
    include: ['profileImage'],
    'fields.image': ['variants.square-small', 'variants.square-small2x'],
  };

  return sdk.currentUser
    .updateProfile(actionPayload, queryParams)
    .then(response => {
      dispatch(updateProfileSuccess(response));

      calculateProfileTier(response.data.data).catch(e => {
        console.warn('Failed to calculate profile tier:', e);
      });

      const entities = denormalisedResponseEntities(response);
      if (entities.length !== 1) {
        throw new Error('Expected a resource in the sdk.currentUser.updateProfile response');
      }
      const currentUser = entities[0];

      // Update current user in state.user.currentUser
      dispatch(currentUserShowSuccess(currentUser));
    })
    .catch(e => dispatch(updateProfileError(storableError(e))));
};

export const loadData = () => (dispatch, getState, sdk) => {
  dispatch(setInitialState());
  return dispatch(fetchCurrentUser());
};
